import { useState, useEffect } from 'react';
import { getOccupancyAndAverageDailyRate } from './data.service';
import { isErrorInfo } from '../../../shared/interfaces/error-info.interface';
import type {
  KPIChartsSearch,
  OccupancyAndAverageDailyRate
} from '../../../shared/models/kpis.model';

export function useOccupancyAndAverageDailyRateData(monthsCount: number, payload: KPIChartsSearch) {
  const [data, setData] = useState<OccupancyAndAverageDailyRate[] | null>(null);

  useEffect(() => {
    if (payload?.query && Object.keys(payload.query).length > 0) {
      setData(null);
      getOccupancyAndAverageDailyRate(monthsCount, payload)
        .then((responseData) => {
          if (!isErrorInfo(responseData)) {
            responseData.reverse();
            setData(responseData);
          }
        })
        .catch((error) => console.error(error));
    }
  }, [monthsCount, payload]);

  return data;
}
